import { CFC } from "@api/types/cypress";
import Error from "@api/types/error";

const TextInput: CFC<{
  field: string;
  value: string;
  error: Error;
  locked: boolean;
  validators?: any[];
  placeholder?: string;
  onChange: (field: string, value: string) => void;
  onBlur: (field: string, validators: any[]) => void;
}> = ({ field, value, error, locked, validators = [], placeholder = "", onChange, onBlur }) => (
  <div className="text-input-container">
    {(!locked && (
      <input
        className={error.active ? "error" : ""}
        type="text"
        value={value}
        onChange={(e) => onChange(field, e.target.value)}
        onBlur={() => onBlur(field, validators)}
        placeholder={placeholder}
      />
    )) || <div className={"input-clone"}>{value}</div>}
    <style jsx>
      {`
        .text-input-container input {
          width: 100%;
          padding: 0.5rem 0.75rem;
        }

        .input-clone {
          width: 100%;
          border: 1px solid rgb(194, 194, 194);
          background: white;
          padding: 0.5rem 0.75rem;
          opacity: 0.5;
        }

        .text-input-container input.error {
          border-color: red;
        }

        @media screen and (min-width: 768px) {
          .text-input-container input {
            width: 50%;
          }
        }
      `}
    </style>
  </div>
);

export default TextInput;
